<template>
    <!-- 팝업 -->
    <div class="pop_up_layer find_account" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail" id="find_account" style="display: block; max-width: 800px">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <template style="display: block">
            <div class="pop_tit">
                <p>상담원 {{ state.mode ? "등록" : "수정" }}</p>
            </div>

            <div class="content_wrap">
                <ul>
                    <li>
                        <span class="starMark">이름</span>
                        <input type="text" placeholder="이름을 입력해주세요." v-model="state.data.name" :disabled="!state.mode" />
                    </li>

                    <li>
                        <span class="starMark">아이디</span>
                        <div class="flex ac id_box">
                            <input
                                type="text"
                                placeholder="아이디를 입력해주세요."
                                v-model="state.data.id"
                                :disabled="!state.mode"
                                @input="state.idIsValid = false"
                            />
                            <button type="button" v-if="state.mode" @click="existCheck">중복확인</button>
                        </div>
                    </li>

                    <li>
                        <span class="starMark">비밀번호</span>
                        <input type="password" placeholder="비밀번호를 입력해주세요." v-model="state.pw" />
                    </li>

                    <li>
                        <span class="starMark">비밀번호 확인</span>
                        <input type="password" placeholder="비밀번호를 입력해주세요." v-model="state.pw_re" />
                    </li>

                    <li>
                        <span class="starMark">담당</span>
                        <input type="text" placeholder="담당을 입력해주세요. (최대 10글자)" v-model="state.data.auas" maxlength="10" />
                    </li>

                    <li>
                        <span class="starMark">부서</span>
                        <div class="select-wrap">
                            <select v-model="state.data.dept">
                                <option :value="0">선택해주세요.</option>
                                <option v-for="item in deptList" :value="item.key" v-text="item.name"></option>
                            </select>
                        </div>
                    </li>

                    <li>
                        <span class="starMark">권한</span>
                        <div class="select-wrap">
                            <select v-model="state.data.auth">
                                <option :value="0">선택해주세요.</option>
                                <option v-for="item in authList" :value="item.key" v-text="item.name"></option>
                            </select>
                        </div>
                    </li>
                </ul>

                <div class="btn_wrap">
                    <button class="submit_btn _gray" @click="closeModal">닫기</button>

                    <button v-if="state.mode" class="submit_btn" @click="confirmAdd">등록</button>
                    <button v-else class="submit_btn" @click="confirmModify">수정</button>
                </div>
            </div>
        </template>
    </div>
    <!-- 팝업 -->

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :gubun="state.gubun"
        @close="state.isShowModal = false"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import { reactive, onMounted, onUnmounted, watch, CommonUtils, types, apiService, ModalDefault, getMessageByCode } from "@/BaseComponent";
    import validate from "@/validate";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                data: {
                    id: "" as string,
                    name: "" as string,
                    auas: "" as string,
                    dept: 0 as number,
                    auth: 0 as number,
                } as types.admin.AdminVOForApi,

                idx: 0 as number,
                pw: "" as string,
                pw_re: "" as string,
                mode: true as boolean, // true: insert, false: update

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                gubun: 1 as 1 | 2 | 3, // 1: update, 2: delete, 3: insert
                idIsValid: false,
            });

            const deptList = [
                { key: 1, name: "상담팀" },
                { key: 3, name: "현장팀" },
                { key: 5, name: "행정감" },
                { key: 6, name: "감시팀" },
            ];

            const authList = [
                { key: 5, name: "5번권한" },
                { key: 6, name: "6번권한" },
                { key: 7, name: "7번권한" },
                { key: 8, name: "8번권한" },
            ];

            onMounted(() => {
                state.idx = props.idx;

                if (state.idx === 0) {
                    state.mode = true;
                } else {
                    detail();
                    state.mode = false;
                }

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.idx = props.idx;

                if (state.idx === 0) {
                    state.mode = true;
                } else {
                    detail();
                    state.mode = false;
                }
            });

            const closeModal = () => {
                emit("close");
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    switch (param.gubun) {
                        case 1:
                            modify();
                            break;
                        case 3:
                            add();
                            break;
                    }
                } else if (param.action === "callback") {
                    emit("callback");
                }
            };

            const detail = async () => {
                const res = await apiService.admin.detail(state.idx);

                if (res.returnCode === 0) {
                    state.data = res.data;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirmAdd = () => {
                const value = {
                    ...state.data,
                    pw: state.pw,
                    pw_re: state.pw_re,
                };
                const checkValue = CommonUtils.checkValidate(validate.admin.add, value);

                if (!state.idIsValid) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "아이디 중복확인을 해주세요.";
                    state.isShowModal = true;
                    return;
                }

                if (checkValue.success) {
                    state.modalTab = 1;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 등록하시겠습니까?";
                    state.isShowModal = true;
                    state.gubun = 3;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = checkValue.message;
                    state.isShowModal = true;
                    return;
                }
            };
            const confirmModify = () => {
                const value = {
                    ...state.data,
                    pw: state.pw,
                    pw_re: state.pw_re,
                };
                const checkValue = CommonUtils.checkValidate(validate.admin.edit, value);
                if (checkValue.success) {
                    state.modalTab = 1;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 변경하시겠습니까?";
                    state.isShowModal = true;
                    state.gubun = 1;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = checkValue.message;
                    state.isShowModal = true;
                    return;
                }
            };

            const add = async () => {
                const param: types.admin.ReqAdmin = {
                    id: state.data.id,
                    pw: state.pw,
                    name: state.data.name,
                    auth: state.data.auth,
                    auas: state.data.auas,
                    dept: state.data.dept,
                };

                const res = await apiService.admin.add(param);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.gubun = 3;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const modify = async () => {
                const param: types.admin.ReqAdminForModify = {
                    idx: state.data.idx,
                    id: state.data.id,
                    pw: state.pw,
                    name: state.data.name,
                    auth: state.data.auth,
                    auas: state.data.auas,
                    dept: state.data.dept,
                };

                const res = await apiService.admin.modify(param);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.gubun = 3;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const existCheck = async () => {
                if (!state.data.id) {
                    state.idIsValid = false;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "아이디를 입력해주세요.";
                    state.isShowModal = true;
                    return;
                }
                const res = await apiService.admin.existCheck(state.data.id);

                if (res.returnCode === 0) {
                    state.idIsValid = true;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "사용 가능합니다.";
                    state.isShowModal = true;
                } else {
                    state.idIsValid = false;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return { state, closeModal, callbackModal, deptList, authList, confirmAdd, confirmModify, existCheck };
        },
    };
</script>

<style scoped>
    .content_wrap {
        margin-top: 20px;
    }
    .content_wrap ul li {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
    }
    .content_wrap ul li > span {
        min-width: 110px;
        margin-right: 10px;
        text-align: left;

        font-family: Noto Sans KR;
        font-weight: 500;
        font-style: Medium;
        font-size: 16px;

        line-height: 100%;
        letter-spacing: 0%;

        color: #252525;
    }

    .content_wrap ul li input {
        display: block;
        width: 100%;

        font-family: Noto Sans KR;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        height: 30px;
        background: #f7f7f9;
        border: 0;
        line-height: 100%;
        letter-spacing: 0%;
        text-align: left;
    }

    .content_wrap .file_wrap label {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        align-items: stretch;

        font-family: Noto Sans KR;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;

        line-height: 100%;
        letter-spacing: 0%;
        text-align: left;
    }

    .content_wraprap input[type="file"] {
        display: none;
    }

    .content_wrap .file_box_wrap {
        flex: calc(100% - 150px);
        height: auto;
        border: 1px solid #d6d6d6;
        border-radius: 5px;
        line-height: 1.5;
        padding: 7px 10px;
        color: #6d6d6d;
        font-weight: 500;
    }

    .content_wrap .file_wrap .form_li_tit {
        min-width: 110px;
        letter-spacing: -0.5px;
        font-weight: 500;
        display: inline-block;
        color: #000;
    }

    .content_wrap .file_wrap .blue_btn {
        width: 140px;
        margin-left: 7px;
        height: auto;
    }

    .content_wrap .file_list {
        padding-left: 0;
        display: flex;
        gap: 15px;
        margin-top: 7px;
        flex-wrap: wrap;
    }

    .content_wrap .file .file_name {
        text-decoration: underline;
        color: #434343;
        transition: 0.2s;
    }

    .content_wrap .file .file_del {
        width: 18px;
        height: 18px;
        vertical-align: middle;
        display: inline-block;
        margin-left: 1px;
        margin-top: -3px;
        transition: 0.2s;
    }

    .content_wrap .file .file_del:hover {
        filter: brightness(1.15);
        transition: 0.2s;
    }

    .id_box input {
        flex: 1;
    }
    .id_box {
        width: 100%;
    }
    .id_box button {
        height: 30px;
        padding: 0 10px;
    }
</style>
